/*
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * External dependencies
 */
import { _x } from '@web-stories-wp/i18n';
import PropTypes from 'prop-types';

const title = _x('Yellow Leaf', 'sticker name', 'web-stories');

function YellowLeaf({ style }) {
  return (
    <svg
      style={style}
      viewBox="0 0 59 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <path
        d="M30.8112 53.684C31.6757 53.8612 32.5563 54.1059 33.4382 54.1293C34.4308 54.1534 35.5315 54.0854 36.4693 53.7862C37.4954 53.4562 38.5493 53.2325 39.5107 52.7436C40.613 52.1868 41.52 51.5316 42.4222 50.691C42.9411 50.1993 43.4123 49.6625 43.9565 49.1845C44.5322 48.6842 45.1196 48.2229 45.6953 47.7226C46.8257 46.7369 48.0753 45.8088 48.9054 44.5311C49.6119 43.4352 50.2319 42.3058 50.609 41.0328C50.9236 39.9613 51.0294 38.8168 51.344 37.7453C51.544 37.0693 51.5512 36.3876 51.7914 35.7462C52.0514 35.0437 52.0686 34.1976 52.0808 33.4337C52.0892 32.7984 51.8392 32.3767 51.5465 31.8277C51.4299 31.5953 51.3311 31.3659 51.2144 31.1334C50.4922 29.7072 49.4058 28.4118 48.487 27.1084C46.7975 24.7119 45.2527 22.1189 43.1965 20.028C41.8772 18.6923 40.5127 17.4041 39.0684 16.2036C37.9083 15.2277 36.7458 14.159 35.4212 13.4407C34.2485 12.804 33.1548 12.4578 31.8731 12.2914C30.7527 12.1529 29.5885 11.8408 28.4612 11.8487C27.5477 11.8476 26.7194 12.1011 25.8189 12.1852C24.7477 12.2952 23.7033 12.1975 22.6242 12.14C21.8381 12.0963 21.0075 11.9895 20.2133 12.0459C19.4296 12.0949 18.6421 12.2724 17.867 12.3782C16.7149 12.5296 15.5809 12.4164 14.4233 12.493C13.8176 12.5266 13.1822 12.5182 12.7413 12.9864C12.3591 13.3817 12.2475 14.0269 12.2082 14.5738C12.1708 15.0565 12.0013 15.3963 11.8669 15.8529C11.6167 16.6587 11.4079 17.5455 11.2727 18.3804C11.1406 19.1973 11.2767 19.9038 11.448 20.7272C11.6749 21.7631 11.8986 22.817 12.0685 23.8616C12.1923 24.6398 12.2413 25.4235 12.4577 26.1993C12.8234 27.4992 12.9536 28.9338 13.553 30.1634C13.798 30.6673 13.9263 31.2063 14.1219 31.7292C14.5822 32.9625 15.1593 34.1606 15.687 35.3778C16.2456 36.6835 16.7472 37.9977 17.3763 39.2694C17.6361 39.7943 17.7923 40.172 17.97 40.6919C18.2426 41.5697 18.7613 42.3054 19.0834 43.1641C19.2716 43.6765 19.3788 44.2304 19.5565 44.7503C19.765 45.3585 19.871 45.866 19.8626 46.5013C19.8323 47.5297 19.9916 48.8493 20.7235 49.6866C21.3232 50.381 22.287 50.9446 23.1026 51.298C23.954 51.6576 24.832 52.0772 25.7386 52.2248C26.1866 52.3023 26.6111 52.5696 27.0541 52.7293C27.5657 52.9193 27.6869 52.9126 28.1887 52.9995C28.3784 53.023 28.5081 53.0732 28.701 53.0789C28.8821 53.0456 29.1026 53.1576 29.285 53.1707C29.4357 53.206 29.8121 53.2711 29.9115 53.3898C30.362 53.5601 30.302 53.5866 30.8112 53.684Z"
        fill="#F9E46C"
      />
      <path
        d="M47.8283 45.2419C43.8559 42.326 39.8488 39.3947 36.2923 35.9661C32.7002 32.5053 29.8471 28.4432 26.8566 24.479C25.1517 22.2197 23.4557 19.9683 21.7587 17.7002C21.5308 17.3984 21.0271 17.7045 21.2639 18.0144C24.282 22.0194 27.2842 26.0419 30.3191 30.0463C33.3264 34.0098 36.7911 37.4505 40.6746 40.5717C42.8724 42.3405 45.1572 44.0133 47.4332 45.6781C47.7411 45.9094 48.1363 45.4732 47.8283 45.2419Z"
        fill="#4C664A"
      />
      <path
        d="M39.8983 39.376C38.7578 39.4388 37.5818 39.6123 36.5201 40.0166C35.4091 40.4397 34.5853 41.1706 33.7416 41.9947C31.9585 43.7309 29.7679 44.8279 27.2697 45.1221C26.8935 45.1625 26.9198 45.7582 27.3039 45.709C29.5266 45.4512 31.6311 44.6098 33.3312 43.1796C34.2696 42.3936 35.0354 41.3877 36.1386 40.8305C37.299 40.2457 38.6499 40.0399 39.9246 39.9716C40.3018 39.948 40.2754 39.3523 39.8983 39.376Z"
        fill="#4C664A"
      />
      <path
        d="M34.4004 34.395C31.6198 34.751 28.8845 35.3069 26.1019 35.6294C23.4694 35.9289 20.8015 36.0534 18.2092 35.3092C17.8409 35.198 17.7231 35.7743 18.0913 35.8855C20.6581 36.6224 23.319 36.5234 25.9357 36.2412C28.7775 35.9248 31.5878 35.3575 34.4267 34.9907C34.8108 34.9416 34.7766 34.3546 34.4004 34.395Z"
        fill="#4C664A"
      />
      <path
        d="M42.8985 41.4905C42.6186 40.5856 42.8186 39.6866 42.985 38.789C43.1306 37.9678 43.2011 37.1581 43.1019 36.3216C42.8955 34.5144 42.1402 32.8135 41.4045 31.1621C41.2497 30.8154 40.6789 30.9813 40.8426 31.3361C41.6069 33.0451 42.4175 34.8279 42.5438 36.7055C42.6574 38.3651 41.8281 40.0124 42.3366 41.6645C42.4421 42.03 43.004 41.8561 42.8985 41.4905Z"
        fill="#4C664A"
      />
      <path
        d="M37.5623 37.2596C37.2735 34.4724 36.9937 31.6932 36.705 28.906C36.4575 26.5373 36.4886 23.8969 35.3445 21.7326C35.1649 21.3952 34.6701 21.7093 34.8496 22.0467C35.4266 23.1413 35.6392 24.3346 35.7777 25.5562C35.9281 26.8361 36.0449 28.1173 36.1784 29.3979C36.4495 32.0262 36.7205 34.6544 36.9837 37.2914C37.0052 37.6604 37.6016 37.6447 37.5623 37.2596Z"
        fill="#4C664A"
      />
      <path
        d="M27.2261 25.7669C24.9943 26.4453 22.7625 27.1237 20.5396 27.8102C20.1761 27.9258 20.3605 28.4899 20.7239 28.3743C22.9557 27.6959 25.1875 27.0175 27.4104 26.331C27.7827 26.2235 27.5984 25.6594 27.2261 25.7669Z"
        fill="#4C664A"
      />
      <path
        d="M30.2022 29.0508C30.5414 28.0874 30.6436 27.0998 30.4833 26.0809C30.3022 24.9956 29.6837 23.9111 29.8463 22.8034C29.8998 22.423 29.3203 22.2951 29.2668 22.6755C29.1211 23.6396 29.4839 24.5243 29.7313 25.4473C30.0318 26.5614 30.0558 27.6951 29.6642 28.77C29.5416 29.1195 30.0717 29.4091 30.2022 29.0508Z"
        fill="#4C664A"
      />
    </svg>
  );
}

YellowLeaf.propTypes = {
  style: PropTypes.object,
};

export default {
  aspectRatio: 59 / 63,
  svg: YellowLeaf,
  title,
};
